import React from "react";
import { DineInTableTile as TileData } from "./dineInBoardBuilder";
import DineInTableTile from "./DineInTableTile";
import "./styles/DineInTableGrid.css";

interface DineInTableGridProps {
  tiles: TileData[];
  now: number;
  onOpenTable: (tableNumber: number) => void;
}

const DineInTableGrid: React.FC<DineInTableGridProps> = ({ tiles, now, onOpenTable }) => (
  <div className="dine-in-grid">
    {tiles.map((tile) => (
      <DineInTableTile
        key={tile.tableNumber}
        tile={tile}
        now={now}
        onOpen={onOpenTable}
      />
    ))}
  </div>
);

export default DineInTableGrid;
